// src/utils/rrLive/rgbSignalUnpack.js

function toNum(x) {
  return typeof x === "number" && Number.isFinite(x) ? x : null;
}

/**
 * Unpack the Firestore-safe packed smooth signal into Chart-friendly samples.
 *
 * Expected packed shape:
 * {
 *   dp: number,
 *   hz: number,
 *   n: number,
 *   stride: number,
 *   t0Sec: number,
 *   t?: number[]   // optional
 *   v: number[]    // required
 * }
 *
 * Output: [{t, value}, ...]
 */
export function unpackSmoothSignal(packed) {
  if (!packed || typeof packed !== "object") return [];

  const v = Array.isArray(packed.v) ? packed.v : [];
  if (!v.length) return [];

  const tArr = Array.isArray(packed.t) ? packed.t : null;

  const hz = toNum(packed.hz) ?? 15;
  const dt = hz > 0 ? 1 / hz : 1 / 15;

  const t0 = toNum(packed.t0Sec) ?? 0;
  const stride = Math.max(1, (toNum(packed.stride) ?? 1) | 0);

  const out = [];
  for (let i = 0; i < v.length; i++) {
    const vv = toNum(v[i]);
    if (vv == null) continue;

    const t = tArr && toNum(tArr[i]) != null ? tArr[i] : t0 + i * stride * dt;

    out.push({ t, value: vv });
  }

  return out;
}
